(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vertice-header"]) return;
  try {
    
document.addEventListener('click', (event) => {
  document.querySelectorAll('.zn-category-menu[open]').forEach((menu) => {
    if (!menu.contains(event.target)) menu.open = false;
  });
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.zn-category-menu[open]').forEach((menu) => {
    if (menu.contains(document.activeElement)) menu.querySelector('summary').focus();
    menu.open = false;
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vertice-market"] && !Shopify.designMode) return;
  try {
    
(()=>{
const shuffle=items=>{for(let i=items.length-1;i>0;i--){const j=Math.floor(Math.random()*(i+1));[items[i],items[j]]=[items[j],items[i]];}return items;};
function init(root){
if(root.dataset.initialized)return;root.dataset.initialized='true';
const grid=root.querySelector('.zn-balanced-grid');
const cards=Array.from(grid.children);let category='all',audience='all';
if(root.dataset.balanced==='true'){
const groups=new Map();cards.forEach(card=>{const key=card.dataset.znCategoryCard+'|'+card.dataset.znAudienceCard;if(!groups.has(key))groups.set(key,[]);groups.get(key).push(card);});
const buckets=shuffle(Array.from(groups.values()).map(shuffle));let more=true;while(more){more=false;for(const bucket of buckets){if(bucket.length){grid.append(bucket.shift());more=true;}}}
}
const ordered=Array.from(grid.children);
function apply(){const seen=new Set();let count=0;
ordered.forEach(card=>{const match=(category==='all'||category===card.dataset.znCategoryCard)&&(audience==='all'||audience===card.dataset.znAudienceCard);const show=match&&!seen.has(card.dataset.znCard);card.hidden=!show;if(show){seen.add(card.dataset.znCard);count++;}});
root.querySelectorAll('[data-zn-category]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.znCategory===category)));
root.querySelectorAll('[data-zn-audience]').forEach(b=>{b.setAttribute('aria-pressed',String(b.dataset.znAudience===audience));b.hidden=b.dataset.znAudience!=='all'&&!cards.some(c=>(category==='all'||c.dataset.znCategoryCard===category)&&c.dataset.znAudienceCard===b.dataset.znAudience);});
root.querySelectorAll('[data-zn-more]').forEach(a=>{a.hidden=category!=='all'&&a.dataset.znMore!==category;});
root.querySelector('[data-zn-catalog-empty]').hidden=count!==0;
root.querySelector('.zn-catalog-count').textContent=String(count);
}
root.addEventListener('click',e=>{const cat=e.target.closest('[data-zn-category]'),person=e.target.closest('[data-zn-audience]');if(cat){category=cat.dataset.znCategory;audience='all';apply();}if(person){audience=person.dataset.znAudience;apply();}});
apply();
}
document.querySelectorAll('[data-zn-catalog]').forEach(init);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-zn-catalog]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zuna-campaigns"] && !Shopify.designMode) return;
  try {
    
function initZunaBanners(scope=document){for(const section of scope.querySelectorAll('[data-zn-banners]')){if(section.dataset.ready)return;section.dataset.ready='true';const track=section.querySelector('[data-zn-banner-track]'),slides=track.children,prev=section.querySelector('[data-zn-banner-prev]'),next=section.querySelector('[data-zn-banner-next]'),position=section.querySelector('[data-zn-banner-position]');if(slides.length<2)continue;const index=()=>Math.max(0,Math.min(slides.length-1,Math.round(track.scrollLeft/track.clientWidth)));const paint=()=>{const i=index();prev.disabled=i===0;next.disabled=i===slides.length-1;position.textContent=(i+1)+' / '+slides.length;};const go=delta=>track.scrollTo({left:Math.max(0,Math.min(slides.length-1,index()+delta))*track.clientWidth,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});prev.addEventListener('click',()=>go(-1));next.addEventListener('click',()=>go(1));track.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();go(e.key==='ArrowRight'?1:-1);}});track.addEventListener('scroll',paint,{passive:true});paint();}}
initZunaBanners();document.addEventListener('shopify:section:load',e=>initZunaBanners(e.target));

  } catch(e) { console.error(e); }
})();
})();
